<div class="spinner-container" *ngIf="visible$ | async">
    <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>